<template>
  <section v-if="params">
    <section v-for="(item, key) in Object.keys(params)" :key="key">
      <span class="t-sm">{{ item }}:</span>
      <br />
      <template v-if="item === 'images'">
        <img
          v-for="(img, k) in params[item]"
          :key="k"
          :src="`data:image/png;base64, ${img}`"
          style="max-width: 400px;"
        />
      </template>
      <template v-else>
        {{ params[item] }}
      </template>
    </section>
  </section>
</template>

<script>
import { parse } from "../utils/tools";

export default {
  props: ["json"],
  data() {
    return {
      params: {}
    };
  },
  created() {
    this.params = parse(this.json);
  }
};
</script>
